import React from "react";

const LogoutIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d="M4.67998 16.6667C4.29609 16.6667 3.97581 16.5384 3.71915 16.2817C3.46248 16.025 3.33387 15.7045 3.33331 15.32V4.68004C3.33331 4.29615 3.46192 3.97587 3.71915 3.71921C3.97637 3.46254 4.29665 3.33393 4.67998 3.33337H10.0158V4.16671H4.67998C4.55165 4.16671 4.43387 4.22004 4.32665 4.32671C4.21942 4.43337 4.16609 4.55115 4.16665 4.68004V15.3209C4.16665 15.4487 4.21998 15.5662 4.32665 15.6734C4.43331 15.7806 4.55081 15.8339 4.67915 15.8334H10.0158V16.6667H4.67998ZM13.7183 12.9492L13.1333 12.3492L15.0658 10.4167H7.65998V9.58337H15.0658L13.1325 7.65004L13.7175 7.05171L16.6666 10L13.7183 12.9492Z"
        fill="#8D8F91"
      />
    </svg>
  );
};

export default LogoutIcon;
